// 静默请求 禁止弹出错误提示
export const whiteList = [
  '/webapi/wx/user/isSubscribe',
  '/webapi/wxoauth/getJsapiSignature',
  '/webapi/zhongcaijie/h5/arsenal/addUseCount',
  '/webapi/zhongcaijie/h5/advertisement/getH5Advertisements',
  '/webapi/api/alivod/h5/getPlayUrl',
  '/webapi/zhongcaijie/h5/growth/shareCurriculumAddGrowth',
  '/webapi/zhongcaijie/h5/userSign/addUserIntegralShare',
  '/webapi/zhongcaijie/h5/company/applyCompany',
]
